import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function MeetYourGuide() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="meetyourguide" ref={sectionRef} className="bg-[#e5e5e5] py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className={cn("flex flex-col items-start transition-all duration-700 delay-100 transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            <span className="text-[#f97a00] font-bold uppercase tracking-widest text-sm mb-4">
              Meet Your Guide
            </span>
            <h2 className="text-[#013183] font-bold text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight font-sans">
              A Medical Marketer Turned Tour Guide
            </h2>
            <div className="text-gray-700 text-lg leading-relaxed space-y-4 font-sans mb-8">
              <p>Hi, I’m Ken (Chen), founder of SayKen Tours. After a 25-year career in medical marketing and communications, where I helped companies raise hundreds of millions of dollars, I decided to channel my storytelling expertise into something deeply personal—telling the story of Israel. I am excited about helping you creates memories you’ll take home and cherish forever. Let’s talk soon!</p>
              
            </div>
            
            <div className="mb-8">
              <p className="text-[#013183] text-2xl md:text-3xl transform -rotate-2" style={{
              fontFamily: '"Caveat", "Brush Script MT", cursive'
            }}>
                Let’s talk soon!
              </p>
            </div>

            <Button asChild className="bg-[#f97a00] hover:bg-[#f97a00]/90 text-white font-bold text-lg px-8 py-6 rounded-md shadow-lg hover:shadow-xl transition-all">
              <Link to="/ContactPage">
                Contact Ken
              </Link>
            </Button>
          </div>

          {}
          <div className={cn("relative transition-all duration-700 delay-300 transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            <div className="relative w-full max-w-md mx-auto lg:max-w-full">
              {}
              <div className="relative z-10 w-4/5 ml-auto rounded-2xl overflow-hidden border-4 border-white shadow-xl">
                <AspectRatio ratio={3 / 4}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/founder_portrait_main.png" alt="Ken, Founder of Milk + Honey" className="object-cover w-full h-full" />
                </AspectRatio>
              </div>

              {}
              <div className="absolute bottom-[-10%] left-0 w-3/5 z-20 rounded-2xl overflow-hidden border-4 border-white shadow-2xl">
                <AspectRatio ratio={1}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/founder_portrait_candid.png" alt="Ken guiding a tour in Jerusalem" className="object-cover w-full h-full" />
                </AspectRatio>
              </div>

              {}
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#f97a00]/10 rounded-full blur-3xl -z-10" />
              <div className="absolute bottom-10 left-10 w-40 h-40 bg-[#013183]/10 rounded-full blur-3xl -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}